import { APICONSTANTS } from './../../constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { BpLineModel } from '../../models/societe-linked/bp/bp-line.model';
import { SocieteLinkedService } from '../societe-linked/societe-linked.service';
import { HostnameService } from '../basic/hostname.service';

@Injectable()
export class BpLineService extends SocieteLinkedService<BpLineModel> {
    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTEBPLIGNE, hostnameService);
  }
  getAllFromBp(idBp: number): Observable<BpLineModel[]> {
    return this.getAllbyId('GetFromBp/', idBp);
  }
}
